/* src/app/features/prestacao-informacoes/acompanhamento-processual/acompanhamento-processual-cadastro.component.scss */
.painel-acompanhamento {
  border: 1px solid #dddddd;
  margin-bottom: 15px;
  margin-top: 15px;
  padding-top: 5px;
}
/*# sourceMappingURL=acompanhamento-processual-cadastro.component.css.map */
